/**
 * MessageRenderer · 消息判别联合分发器（v4）
 *
 * v4 改动：ChatMessage 联合简化为 TextMessage（user）| AssistantMessage（ai），
 * 分发也对应简化。
 */

import React from 'react'
import type { ChatMessage } from '../../../../../../types/ai-classify'
import MessageText from '../MessageText'
import MessageAssistant from '../MessageAssistant'

export interface MessageRendererProps {
  message: ChatMessage
}

const MessageRenderer: React.FC<MessageRendererProps> = ({ message }) => {
  switch (message.kind) {
    case 'text':
      return <MessageText message={message} />
    case 'assistant':
      return <MessageAssistant message={message} />
    default: {
      const _exhaustive: never = message
      return _exhaustive
    }
  }
}

export default MessageRenderer
